"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
function useDebounceFunction(callback) {
    const callbackRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        callbackRef.current = callback;
    }, [callback]);
    const debouncedCallback = (0, react_1.useMemo)(() => {
        const func = () => {
            const storedCallback = callbackRef.current;
            if (storedCallback) {
                storedCallback();
            }
        };
        return (0, lodash_1.debounce)(func, 400);
    }, []);
    return debouncedCallback;
}
exports.default = useDebounceFunction;
